import LandingPage, { type LandingPageData } from "./landing";
import { landingContent } from "@shared/landing-content";
import SignalShowcase from "@/components/SignalShowcase";

const data: LandingPageData = {
  path: "/signal",
  seo: {
    nl: {
      title: "Wrkt Signal: Competitive Ad Intelligence voor D2C | Wrkt Digital",
      description: "Wrkt Signal is de eigen AI-tool van Wrkt Digital: honderden concurrent-ads per scan, geclassificeerd op angle en format, vertaald naar concrete testkansen.",
      keywords: "Wrkt Signal, competitive ad intelligence, concurrentie analyse meta ads, ad library analyse, concurrenten advertenties bekijken, creative intelligence tool, AI marketing tool, concurrentieonderzoek e-commerce, ad spy tool alternatief, advertentie analyse tool",
    },
    en: {
      title: "Wrkt Signal: Competitive Ad Intelligence for D2C | Wrkt Digital",
      description: "Wrkt Signal is Wrkt Digital's proprietary AI tool: hundreds of competitor ads per scan, classified by angle and format, translated into concrete testing opportunities.",
      keywords: "Wrkt Signal, competitive ad intelligence, competitor ad analysis, ad library analysis, view competitor ads, creative intelligence tool, AI marketing tool, competitive research e-commerce, ad spy tool alternative, ad analysis tool",
    },
  },
  content: landingContent["/signal"],
  extra: <SignalShowcase />,
};

export default function LandingSignal() {
  return <LandingPage data={data} />;
}
